export default __webpack_public_path__ + "static/media/game_image-min.7d1f2baa.png";